import StickyFill from 'stickyfilljs';

const Sticky = () => {
  const el = document.querySelectorAll('.js-sticky');
  StickyFill.add(el);
}

export default Sticky;


// WEBPACK FOOTER //
// ./src/recruit/js/sticky.js